import React from 'react';
import styled from 'styled-components';
import { OnBoardLogo } from '../assets/images/svgs';
import {
  CredusButton,
  CredusHeading,
  CredusInput,
  CredusText,
  CredusWrapper,
  color,
} from 'ui';
import { Link } from 'react-router-dom';

const ForgotPassword: React.FC = () => {
  return (
    <Container>
      <OnBoardLogo />
      <CredusWrapper mt="2rem" display="flex" flex="1" justify="center">
        <CredusWrapper
          pl="1rem"
          display="flex"
          direction="column"
          justify="space-between"
          w="40%"
        >
          <div>
            <CredusHeading
              className="slideBottom"
              as="h3"
              align="center"
              weight="medium"
            >
              <ColoredText>Change</ColoredText> Password,
            </CredusHeading>

            <FormWrap>
              <CredusHeading as="h4" align="center" weight="regular">
                You are about to change Your Password
              </CredusHeading>
              <CredusWrapper mt="2.4rem">
                <CredusInput label="Email" />
              </CredusWrapper>
              <CredusButtonWrap size="medium" variant="primary">
                Change Password
              </CredusButtonWrap>
              <CredusWrapper
                mt="2rem"
                display="flex"
                align="center"
                justify="center"
              >
                <Link to="/login">
                  <CredusText size="md" weight="medium" align="center">
                    Back To Login
                  </CredusText>
                </Link>
              </CredusWrapper>
            </FormWrap>
          </div>
          <CredusWrapper>
            <CredusText mt="3.2rem" size="md" weight="regular" align="center">
              Having technical difficulties ? Say hello to
              <WrappedLink to="mailto:credussupport@mail.com" target="_blank">
                credussupport@mail.com
              </WrappedLink>
            </CredusText>
          </CredusWrapper>
        </CredusWrapper>
      </CredusWrapper>
    </Container>
  );
};

export default ForgotPassword;

const Container = styled.div`
  background: #fff;
  padding: 2.8rem 5rem 3rem 7rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
`;

const ColoredText = styled.span`
  color: ${color.primary};
`;
const FormWrap = styled.form`
  margin-top: 3.6rem;
  height: 524px;
  background: #f5f6f8;
  border-radius: 4px;
  padding: 72px 72px 55px;
`;
const CredusButtonWrap = styled(CredusButton)`
  margin-top: 2.9rem;
  width: 100%;
  padding: 0.75rem 9.625rem;
`;

const WrappedLink = styled(Link)`
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  margin-left: 5px;
`;
